import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { FixingOrder } from '@/store/orders/fixing/state.ts';

export const SavedFixingOrderValidator = arkScope.type({
  type: '"FixingOrder"',
  properties: {
    status: arkScope
      .type({ type: "'creating'" })
      .or({ type: "'pending'" })
      .or({ type: "'failed'", errorMessage: 'string' })
      .or({ type: "'submitted' | 'editing' | 'cancelled'", tradeId: 'string' }),
    clientWay: "'buy' | 'sell'",
    'notional?': 'number',
    notionalCurrencyIndex: '1 | 2',

    'currencyPair?': {
      currency1: 'string',
      currency2: 'string',
      tiering: 'string?',
    },

    fixingReference: 'string',
    'fixingPlace?': 'string',
    'fixingTime?': 'string',
    fixingPriceType: "'MID' | 'BIDASK'",
    'fixingDateUtc?': 'string',
    'expiryDay?': 'string',
    'commercialMargin?': 'number',
    fixingMarginType: "'BidAskMidSpread' | 'MarginInBps'",

    fixingTimesOfSelectedType: 'string[]',
    fixingTypes: 'string[]',
    sourceNameOfSelectedType: 'string[]',
    canModifyMarginInBps: 'boolean',
    isStandardGroup: 'boolean',
    isCcyForcedBidAsk: 'boolean',

    'notificationEmails?': 'string[]',

    isReadyToSubmit: 'boolean',
    'clockOffset?': 'number',

    mode: "'EDIT' | 'VIEW'",
  },
  tileId: 'string',
  clientId: 'number?',
});

export type SavedFixingOrder = typeof SavedFixingOrderValidator.infer;

export const SavedFixingOrder = {
  fromFxFixingOrder: (fxTile: FixingOrder, tileId: string): SavedFixingOrder => ({
    type: 'FixingOrder',
    properties: fxTile.properties,
    tileId,
    clientId: fxTile.clientId,
  }),
} as const;
